import e from "@dialpad/dialtone-tokens/layered/themes/tokens-nightshade-colors.css?inline";
//#region themes/nightshade.js
var t = {
	brand: {
		css: e,
		name: "nightshade"
	},
	material: { name: "iron" }
};
//#endregion
export { t as default };
